export default class Task {

    /**
     * Typically, Task subclasses are instantiated using a factory which will inject dependencies.
     */
    constructor() {
    }

    
    /**
     * Executes the task.
     * 
     * Note: this method must be overriden by the Task implementation
     * 
     * @param {function(Task):void} callback Task completion callback function
     * @param {function(Task, number):void} progressCallback Task progress callback function
     */
    execute(callback, progressCallback) {
        //override!
    }

}